module.exports = require("./sat.js");